// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMessage-errorMessage-qd6U_ {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.ViewMessage-space1-IAIb3 {
	margin-bottom: 6px !important;
}
.ViewMessage-space2-xOEty {
	margin-bottom: 12px !important;
}
.ViewMessage-space3-GGnhJ {
	margin-bottom: 18px !important;
}
.ViewMessage-space4-LsssU {
	margin-bottom: 24px !important;
}
.ViewMessage-space5-WLoOz {
	margin-bottom: 30px !important;
}
.ViewMessage-space6-bFgEM {
	margin-bottom: 36px !important;
}
.ViewMessage-space7-Ii5x2 {
	margin-bottom: 42px !important;
}
.ViewMessage-spaceTop8-lvOg2 {
	margin-bottom: 48px !important;
}
.ViewMessage-spaceTop1-BYJfd {
	margin-top: 6px !important;
}
.ViewMessage-spaceTop2-nMoJy {
	margin-top: 12px !important;
}
.ViewMessage-spaceTop3-JXdXB {
	margin-top: 18px !important;
}
.ViewMessage-spaceTop4-P9W8F {
	margin-top: 24px !important;
}
.ViewMessage-spaceTop5-BWiQj {
	margin-top: 30px !important;
}
.ViewMessage-spaceTop6-bKwYl {
	margin-top: 36px !important;
}
.ViewMessage-spaceTop7-LDaxa {
	margin-top: 42px !important;
}
.ViewMessage-spaceTop8-lvOg2 {
	margin-top: 48px !important;
}
.ViewMessage-noMargin-VFPXH {
	margin: 0px !important;
}
.ViewMessage-padding1-Ya88_ {
	padding-bottom: 6px !important;
}
.ViewMessage-padding2-wNoGn {
	padding-bottom: 12px !important;
}
.ViewMessage-padding3-isTUb {
	padding-bottom: 18px !important;
}
.ViewMessage-padding4-oAkjx {
	padding-bottom: 24px !important;
}
.ViewMessage-padding5-R2Yvd {
	padding-bottom: 30px !important;
}
.ViewMessage-padding6-rf9AJ {
	padding-bottom: 36px !important;
}
.ViewMessage-padding7-jrY7n {
	padding-bottom: 42px !important;
}
.ViewMessage-paddingTop1-PUsTy {
	padding-top: 6px !important;
}
.ViewMessage-paddingTop2-X_rL1 {
	padding-top: 12px !important;
}
.ViewMessage-paddingTop3-E1vwo {
	padding-top: 18px !important;
}
.ViewMessage-paddingTop4-EJ8Uy {
	padding-top: 24px !important;
}
.ViewMessage-paddingTop5-S2WC7 {
	padding-top: 30px !important;
}
.ViewMessage-paddingTop6-yUzut {
	padding-top: 36px !important;
}
.ViewMessage-paddingTop7-irfLZ {
	padding-top: 42px !important;
}
.ViewMessage-noPadding-w0U7c {
	padding: 0px !important;
}
.ViewMessage-textBold-MPjjr {
	font-weight: 500 !important;
}
.ViewMessage-textBolder-QmYCz {
	font-weight: 700 !important;
}
.ViewMessage-textNormal-BcwMP {
	font-weight: normal !important;
}
.ViewMessage-spaceBottom20-xQqMC {
	margin-bottom: 20px;
}
.ViewMessage-spaceBottom10-YPNdE {
	margin-bottom: 10px;
}
.ViewMessage-marginNone-cCfDh {
	margin: 0;
}
.ViewMessage-spaceBottom15-caeBZ {
	margin-bottom: 15px;
}
.ViewMessage-marginTopNone-CieKW {
	margin-top: 0;
}
.ViewMessage-spaceTop11-bsrgf {
	margin-top: 11px;
}
.ViewMessage-spaceTop21-jlaRC {
	margin-top: 21px;
}
.ViewMessage-spaceTop20-ACx8F {
	margin-top: 20px;
}
.ViewMessage-spaceTop10-Q37c6 {
	margin-top: 10px;
}
/*New Design Text Colors */
.ViewMessage-textDarkBlue-Pb7zA {
	color: rgb(20, 39, 94) !important;
}
.ViewMessage-textLightBlue-UYkIK {
	color: rgb(57, 87, 106) !important;
}
.ViewMessage-textLightSandleGreen-3NU0a {
	color: rgb(76, 86, 41) !important;
}
.ViewMessage-textLightBrown-rJZ69 {
	color: rgb(115, 79, 33) !important;
}
.ViewMessage-textMediumMaroon-t0qxE {
	color: rgb(87, 37, 51) !important;
}
.ViewMessage-textBrown-C82zZ {
	color: rgb(160, 47, 24) !important;
}
.ViewMessage-textMaroon-XQY58 {
	color: rgb(155, 49, 67) !important;
}
.ViewMessage-textDarkBrown-i_0qc {
	color: rgb(83, 18, 16) !important;
}
.ViewMessage-textMediumBrown-sVMVP {
	color: rgb(142, 28, 10) !important;
}
.ViewMessage-textSkyBlue-BPkzI {
	color: rgb(37, 117, 141) !important;
}
.ViewMessage-textGray-kvrP_ {
	color: rgb(77, 65, 51) !important;
}
/*************************Common Styles start******************************************/
.ViewMessage-btnRadius-uBhQB {
	border-radius: 4px;
}
.ViewMessage-linkBtn-NcUzO {
	border-radius: 4px;
	padding: 12px 21px;
}
.ViewMessage-noMargin-VFPXH {
	margin: 0px;
}
.ViewMessage-noBorder-xX3_Z {
	border: 0px none !important;
}
/*************************Common Styles end******************************************/
/*************************Sidenavigation Styles start******************************************/
.ViewMessage-sidebarDesign-ksVav {
	padding: 50px 0 30px;
	background: var(--background-primary);
}
.ViewMessage-sidebarContainer-MQYxE {
	border: 1px solid var(--primary-border);
	border-radius: 8px;
	padding: 20px;
}
.ViewMessage-textCenter-xGfiz {
	text-align: center;
}
.ViewMessage-profileAvatarSection-YnpHB {
	position: relative;
	margin: 0 auto;
}
.ViewMessage-profileAvatarLink-JbY1f {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	border-radius: 50%;
}
.ViewMessage-profileName-lQGzp {
	font-size: 16px;
}
.ViewMessage-profileDetail-RmhC9 {
	font-size: 12px;
	color: var(--secondary-foreground);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
.ViewMessage-horizontalLine-MU77P {
	margin-top: 15px;
	margin-bottom: 15px;
	border: 0;
	border-top: 2px solid var(--primary-border);
}
.ViewMessage-textGray-kvrP_ {
	color: var(--secondary-foreground);
}
.ViewMessage-textBold-MPjjr {
	font-weight: bold;
}
.ViewMessage-textLeft-JHA8n {
	text-align: left;
}
.ViewMessage-textRight-nJUVX {
	text-align: right;
}
/*************************Sidenavigation Styles End******************************************/
/*************************Message Styles start******************************************/
.ViewMessage-contextPadding-PKgP_ {
	padding: 20px;
	border-radius: 8px;
}
.ViewMessage-rowCondensed-_zS5a {
	margin-left: -6px;
	margin-right: -6px;
}
.ViewMessage-textBody-sSpow {
	margin: 0;
	padding: 20px;
	text-align: left;
}
.ViewMessage-bottomButton-X0ib6 {
	text-align: right;
	padding: 20px;
}
.ViewMessage-textAreaBox-h1x3R {
	height: 77px !important;
	border: 0px;
	margin-top: 0;
	-webkit-box-shadow: none;
	        box-shadow: none;
	border: 1px solid var(--primary-border);
	resize: none;
}
.ViewMessage-textAreaBox-h1x3R:focus,
.ViewMessage-textAreaBox-h1x3R:active {
	border: 1px solid var(--primary-border) !important
}
.ViewMessage-btnRight-m9LgW {
	margin-left: 10px;
}
.ViewMessage-timeText-vvxwy {
	color: var(--secondary-foreground);
}
.ViewMessage-timeText-vvxwy:hover,
.ViewMessage-timeText-vvxwy:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	outline: none;
}
/*************************Chat bubble Right & Left Styles start******************************************/
.ViewMessage-panelQuote-gE5KC {
	margin-left: 0;
	margin-right: 0;
	position: relative;
	border-radius: 0px;
}
.ViewMessage-panelBubble-WSPGO {
	display: block;
	position: relative;
	height: auto;
	border-radius: 0;
	border: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.ViewMessage-panelBubbleLeft-dOsS2::before {
	content: ' ';
	position: absolute;
	display: inline-block;
	width: 0;
	height: 0;
	bottom: auto;
	border: 10px solid transparent;
	border-left: 0;
	top: 0px;
	left: initial;
	right: 100%;
	border-width: 0 24px 24px 0;
	border-color: transparent var(--primary-input-bg) transparent transparent;
}
.ViewMessage-panelBubbleLeft-dOsS2::after {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	left: -20px;
	right: auto;
	top: 0px;
	bottom: auto;
	border-width: 0 22px 22px 0;
	border-color: transparent var(--primary-gray-bg) transparent transparent;
}
.ViewMessage-panelBubbleRight-H8nLV::before {
	content: "";
	display: inline-block;
	position: absolute;
	right: -33px;
	top: 0px;
	left: 100%;
	border: 10px solid transparent;
	border-width: 25px 25px 0 0;
	border-color: var(--primary-input-bg) transparent transparent;
	z-index: 3;
}
.ViewMessage-panelBubbleRight-H8nLV::after {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	left: -20px;
	right: auto;
	top: 0px;
	bottom: auto;
	border-width: 0 25px 25px 0;
	border-color: transparent var(--primary-border) transparent transparent;
}
.ViewMessage-radiusColor-sRFF0::after {
	content: '';
	position: absolute;
	right: -43px;
	top: -1px;
	left: auto;
	width: 43px;
	height: 46px;
	background: var(--primary-gray-bg);
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
	z-index: 3;
}
.ViewMessage-radiusColorTwo-YXesC::after {
	content: '';
	position: absolute;
	left: -37px;
	top: 0;
	right: auto;
	width: 38px;
	height: 46px;
	background: var(--primary-gray-bg);
	border-top-right-radius: 30px;
	border-bottom-left-radius: 30px;
	z-index: 3;
}
.ViewMessage-panelText-gfVAg {
	word-break: break-all !important;
}
/*************************Chat bubble Right & Left Styles end******************************************/
/*************************Notification Message Styles start******************************************/
.ViewMessage-horizontalText-cC8Kr {
	overflow: hidden;
	text-align: center;
}
.ViewMessage-textWrapper-LAg_d {
	position: relative;
}
.ViewMessage-textWrapper-LAg_d::before {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--primary-border);
	width: 500px;
	top: 50%;
	right: 100%;
	margin-right: 18px;
}
.ViewMessage-textWrapper-LAg_d::after {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--primary-border);
	width: 500px;
	top: 50%;
	left: 100%;
	margin-left: 18px;
}
/*************************Notification Message Styles end******************************************/
.ViewMessage-horizondalLine-ZncGa {
	margin-top: 20px;
	margin-bottom: 20px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}
.ViewMessage-textLeft-JHA8n {
	text-align: left;
}
.ViewMessage-textRight-nJUVX {
	text-align: right;
}
.ViewMessage-textGray-kvrP_ {
	color: var(--secondary-foreground);
	font-size: 14px;
}
.ViewMessage-chevronIcon-Dbvm9 {
	font-size: 1.5em;
	margin-top: 10px;
	font-weight: normal;
	font-style: normal;
}
.ViewMessage-timerIcon-XVOBb {
	font-size: 1.5em;
	font-weight: normal;
	font-style: normal;
	position: relative;
	bottom: 2px;
}
.ViewMessage-checkInDate-sN1Q4 {
	font-size: 14px;
	color: var(--primary-foreground);
}
.ViewMessage-pullLeft-v6Sg0 {
	float: left;
}
.ViewMessage-pullRight-lhseh {
	float: right;
}
/** Discount **/
.ViewMessage-discountText-IrbbM {
	color: var(--discountAndSpecial-color);
}
a,
a:hover,
a:focus,
a:active {
	text-decoration: none;
}
.ViewMessage-paddingRight-PNRo8 {
	padding: 0 0 0 35px;
}
.ViewMessage-displayTable-IENsR {
	width: 100%;
	display: table;
}
.ViewMessage-displayTableRow-Ghwre {
	width: 100%;
	display: table-row;
}
.ViewMessage-displayTableCell-tGyHw {
	display: table-cell;
	vertical-align: top;
}
.ViewMessage-displayTableWidth-h4VNN {
	width: 100%;
	position: relative;
}
.ViewMessage-profileAvatarSection-YnpHB {
	margin: 0 0 0 6px;
	position: relative;
	z-index: 5;
}
.ViewMessage-displayTableCellTop-rqz6z {
	display: table-cell;
	vertical-align: top;
}
.ViewMessage-profileAvatarSectionLeft-YdIba {
	position: relative;
	z-index: 5;
	margin: 0px 6px 0 0px;
}
.ViewMessage-centerChatIcon-vQCgS {
	height: 45px;
	width: 45px;
	margin-left: -20px;
	margin-right: -20px;
	position: relative;
	z-index: 2;
	text-align: center;
	display: inline-block;
	vertical-align: middle;
}
.ViewMessage-instantIcon-iB4lT {
	margin-top: -4px;
}
.ViewMessage-positionR-H8D2Y {
	position: relative;
}
.ViewMessage-infoContentBlock-d6sns {
	background-color: var(--tertiary-gray-bg);
}
.ViewMessage-contentBlockHeading-JjD4g {
	font-size: 18px;
	margin-bottom: 12px;
	margin-top: 0;
	font-weight: 600;
}
.ViewMessage-contentSectionBtn-zBagA {
	margin-top: 20px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
.ViewMessage-contentSubText-TSfjx {
	font-size: 16px;
	color: var(--secondary-foreground);
}
/* =============New css ================*/
.ViewMessage-tripDetailHeading-UZDXp {
	font-size: 16px;
}
.ViewMessage-tripDetailGrey-oMHFu {
	color: var(--secondary-foreground);
	font-size: 16px;
}
.ViewMessage-paymentDetailText-bAaBv {
	color: var(--secondary-foreground);
	font-size: 16px;
	margin-bottom: 10px;
}
.ViewMessage-paymentTotal-AfmyK {
	font-size: 18px;
}
.ViewMessage-messageBoxBg-MCCfR {
	background-color: var(--primary-gray-bg);
	padding: 20px 20px 40px 20px;
	border-radius: 8px;
}
.ViewMessage-messageBoxStyle-rvjZd {
	width: 90%;
}
.ViewMessage-topMessageBar-DSzvM {
	background-color: transparent;
}
.ViewMessage-messageSendIcon-Is4o4,
.ViewMessage-messageSendIcon-Is4o4:hover,
.ViewMessage-messageSendIcon-Is4o4:active,
.ViewMessage-messageSendIcon-Is4o4:focus {
	background: transparent !important;
	border: 0 !important;
	outline: none;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	padding: 0;
	position: relative;
	z-index: 5
}
.ViewMessage-paddingNone-uR88F {
	padding: 0;
}
.ViewMessage-messageBoxSection-U5zf0 {
	padding: 20px;
	background-color: var(--primary-gray-bg);
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}
.ViewMessage-panelBubble-WSPGO {
	margin-bottom: 0;
}
.ViewMessage-userDetailSec-QdzIo {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	gap: 18px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 22px;
}
.ViewMessage-userDetailHostName-LTe2q {
	font-size: 16px;
}
.ViewMessage-font16-ZOxWA {
	font-size: 16px;
}
.ViewMessage-nameSection-pjfDN {
	margin-bottom: 8px;
}
.ViewMessage-verifyReviewCountSec-je5yV {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 3px;
}
.ViewMessage-statusText-rdQM4 {
	font-size: 16px;
	padding-right: 8px;
}
.ViewMessage-dotText-s6qBx {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: var(--primary-foreground);
	position: absolute;
	top: 38%;

}
.ViewMessage-dateText-AjI2I {
	font-size: 14px;
	color: var(--secondary-foreground);
	padding-left: 8px;
}
.ViewMessage-messageThreadSection-tq626 {
	padding: 0 20px 40px 20px;
}
.ViewMessage-topRadiusColor-iNb18::after {
	right: 50px;
	top: 20px;
	border-left: 1px solid var(--primary-border);
}
.ViewMessage-topMessageBar-DSzvM::before {
	right: -23px;
	top: 1px;
	left: auto;
}
.ViewMessage-panelBubbleLeft-dOsS2 {
	background-color: var(--primary-input-bg);
	padding: 17px;
}
.ViewMessage-panelSendToBubble-iuPr8 {
	background-color: var(--primary-input-bg);
	padding: 17px;
}
.ViewMessage-fromRadius-FpRaN:after {
	left: 0px;
	top: 0;
	right: auto;
	width: 46px;
	border-top-right-radius: 30px;
	border-bottom-left-radius: 30px;
}
.ViewMessage-toRadius-TWtHL:after {
	right: 4px;
	top: -1px;
	left: auto;
	width: 46px;
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
}
.ViewMessage-panelSendToBubble-iuPr8:before {
	border-color: var(--primary-input-bg) transparent transparent;
}
.ViewMessage-panelSendToBubble-iuPr8::after {
	content: '';
	position: absolute;
	right: -45px;
	top: -1px;
	left: auto;
	width: 46px;
	height: 46px;
	background: var(--primary-gray-bg);
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
	z-index: 3;
	-webkit-transform: rotate(-14deg);
	    -ms-transform: rotate(-14deg);
	        transform: rotate(-14deg);

}
.ViewMessage-panelLeftMessage-tD7RT {
	border-radius: 0 8px 8px 8px;
}
.ViewMessage-panelRightMessage-L3cmO {
	border-radius: 8px 0 8px 8px;
}
.ViewMessage-messageDateText-gxvf0 {
	color: var(--secondary-foreground);
	font-size: 10px;
}
.ViewMessage-txtBreak-jqn0N {
	word-break: break-word;
}
.ViewMessage-messageProfilePicSec-sdBId {
	width: 50px;
}
.ViewMessage-width100-hzWDg {
	width: 100%;
}
.ViewMessage-messageBoxFlex-vT5gZ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
}
.ViewMessage-profileAvatarSection-YnpHB {
	width: 48px;
}
.ViewMessage-profileAvatarSectionLeft-YdIba .ViewMessage-profileAvatarLink-JbY1f {
	position: relative;
	right: 3px;
	top: 1px;
}
.ViewMessage-tripCheckinCheckout-e87nj {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}
.ViewMessage-userDetailDotText-yHqHM {
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background-color: var(--secondary-foreground);
	position: relative;
	margin-top: 7px;
	margin-left: 7px;
	margin-right: 7px;
}
.ViewMessage-tripArrowSec-Bjmoo {
	margin: 0 10px;
}
.ViewMessage-checkDate-Z_6ag {
	word-break: break-word;
}
.ViewMessage-paymentFlex-dOcgj {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-column-gap: 5px;
	   -moz-column-gap: 5px;
	        column-gap: 5px;
}
.ViewMessage-timerSection-E1CMl {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 3px;
	   -moz-column-gap: 3px;
	        column-gap: 3px;
}
/* ==============New css============== */
.ViewMessage-msgSendIcon-MRFzy {
	width: 100%;
	max-width: 72px;
	min-width: 72px;
}
@media (max-width: 1023px) and (min-width: 768px) {
	.ViewMessage-noPaddingRight-HhJpc {
		padding-right: 0;
	}

	.ViewMessage-centerChatIcon-vQCgS {
		height: 40px;
		width: 40px;
	}

	.ViewMessage-hostNameColor-dZVwR {
		color: var(--primary-foreground) !important;
	}
}
@media (max-width: 767px) {
	.ViewMessage-paddingRight-PNRo8 {
		padding: 0 0 0 0;
	}

	.ViewMessage-panelBubbleRight-H8nLV::before {
		display: none !important;
	}

	.ViewMessage-panelBubbleLeft-dOsS2::before {
		display: none !important;
	}

	.ViewMessage-panelBubbleRight-H8nLV::after {
		display: none;
	}

	.ViewMessage-panelBubbleLeft-dOsS2::after {
		display: none;
	}

	.ViewMessage-profileAvatarSection-YnpHB {
		margin: 0 0 0 13px;
	}

	.ViewMessage-displayTableWidth-h4VNN {
		width: 100%;
	}

	.ViewMessage-displayTableWidthTwo-um83u {
		width: 20%;
	}

	.ViewMessage-profileAvatarSectionLeft-YdIba {
		margin: 0 10px 0 0;
		position: relative;
		z-index: 5;
	}

	.ViewMessage-radiusColor-sRFF0::after {
		display: none;
	}

	.ViewMessage-radiusColorTwo-YXesC::after {
		display: none;
	}

	.ViewMessage-displayTableCell-tGyHw {
		display: table-cell;
		vertical-align: middle;
	}

	.ViewMessage-tripDetailGrey-oMHFu {
		font-size: 14px;
	}

	.ViewMessage-paymentDetailText-bAaBv {
		font-size: 14px;
	}

	.ViewMessage-paymentTotal-AfmyK {
		font-size: 16px;
	}

	.ViewMessage-tripDetailHeading-UZDXp {
		font-size: 15px;
	}

	.ViewMessage-userDetailSec-QdzIo {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.ViewMessage-profileDetail-RmhC9 {
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.ViewMessage-msgSendIcon-MRFzy {
		max-width: 55px;
		min-width: 55px;
	}

	.ViewMessage-panelLeftMessage-tD7RT {
		border-radius: 8px !important;
	}

	.ViewMessage-panelRightMessage-L3cmO {
		border-radius: 8px !important;
	}

	.ViewMessage-sidebarDesign-ksVav {
		padding-top: 25px;
	}
}
@media screen and (max-width: 768px) {
	.ViewMessage-hideSm-Fc3ir {
		display: none;
	}
}
@media (max-width: 320px) {
	.ViewMessage-noPaddingRight-HhJpc {
		padding-right: 0;
	}
}
.ViewMessage-displayFlex-FAZol {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
@media screen and (min-width:768px) {
	.ViewMessage-messageSendBtnSec-en4pi {
		position: relative;
	}

	.ViewMessage-messageSendIcon-Is4o4::before {
		content: '';
		position: absolute;
		width: 25px;
		height: 1px;
		background-color: var(--primary-border);
		left: -3px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/ViewMessage/ViewMessage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,uFAAuF;AACvF;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,2BAA2B;AAC5B;AAEA,qFAAqF;AACrF,+FAA+F;AAC/F;CACC,oBAAoB;CACpB,qCAAqC;AACtC;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA,6FAA6F;AAC7F,wFAAwF;AACxF;CACC,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,SAAS;CACT,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,WAAW;CACX,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;CAChB,uCAAuC;CACvC,YAAY;AACb;AAEA;;CAEC;AACD;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,kCAAkC;AACnC;AAEA;;CAEC,kCAAkC;CAClC,qBAAqB;CACrB,aAAa;AACd;AAEA,yGAAyG;AACzG;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,8BAA8B;CAC9B,cAAc;CACd,QAAQ;CACR,aAAa;CACb,WAAW;CACX,2BAA2B;CAC3B,yEAAyE;AAC1E;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,2BAA2B;CAC3B,wEAAwE;AACzE;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,8BAA8B;CAC9B,2BAA2B;CAC3B,6DAA6D;CAC7D,UAAU;AACX;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,2BAA2B;CAC3B,uEAAuE;AACxE;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,4BAA4B;CAC5B,gCAAgC;CAChC,UAAU;AACX;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,6BAA6B;CAC7B,+BAA+B;CAC/B,UAAU;AACX;AAEA;CACC,gCAAgC;AACjC;AAEA,uGAAuG;AACvG,qGAAqG;AACrG;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,8CAA8C;CAC9C,YAAY;CACZ,QAAQ;CACR,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,8CAA8C;CAC9C,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,iBAAiB;AAClB;AAEA,mGAAmG;AACnG;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,WAAW;AACZ;AAEA;CACC,YAAY;AACb;AAEA,eAAe;AACf;CACC,sCAAsC;AACvC;AAEA;;;;CAIC,qBAAqB;AACtB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,cAAc;AACf;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,qBAAqB;AACtB;AAGA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA,yCAAyC;AACzC;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wCAAwC;CACxC,4BAA4B;CAC5B,kBAAkB;AACnB;AAEA;CACC,UAAU;AACX;AAEA;CACC,6BAA6B;AAC9B;AAEA;;;;CAIC,kCAAkC;CAClC,oBAAoB;CACpB,aAAa;CACb,mCAA2B;SAA3B,2BAA2B;CAC3B,UAAU;CACV,kBAAkB;CAClB;AACD;AAEA;CACC,UAAU;AACX;AAEA;CACC,aAAa;CACb,wCAAwC;CACxC,2BAA2B;CAC3B,4BAA4B;AAC7B;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;CACT,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;AAEA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,2CAA2C;CAC3C,kBAAkB;CAClB,QAAQ;;AAET;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;AAClB;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,WAAW;CACX,SAAS;CACT,4CAA4C;AAC7C;AAEA;CACC,YAAY;CACZ,QAAQ;CACR,UAAU;AACX;AAEA;CACC,yCAAyC;CACzC,aAAa;AACd;AAEA;CACC,yCAAyC;CACzC,aAAa;AACd;AAEA;CACC,SAAS;CACT,MAAM;CACN,WAAW;CACX,WAAW;CACX,6BAA6B;CAC7B,+BAA+B;AAChC;AAEA;CACC,UAAU;CACV,SAAS;CACT,UAAU;CACV,WAAW;CACX,4BAA4B;CAC5B,gCAAgC;AACjC;AAEA;CACC,6DAA6D;AAC9D;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,4BAA4B;CAC5B,gCAAgC;CAChC,UAAU;CACV,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;;AAE1B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,WAAW;AACZ;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,6CAA6C;CAC7C,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,cAAc;AACf;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;AAEA,wCAAwC;AACxC;CACC,WAAW;CACX,eAAe;CACf,eAAe;AAChB;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,2CAA2C;CAC5C;AACD;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,iBAAiB;CAClB;AACD;AAEA;CACC;EACC,aAAa;CACd;AACD;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,UAAU;CACX;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n/*************************Common Styles start******************************************/\n.btnRadius {\n\tborder-radius: 4px;\n}\n\n.linkBtn {\n\tborder-radius: 4px;\n\tpadding: 12px 21px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n/*************************Common Styles end******************************************/\n/*************************Sidenavigation Styles start******************************************/\n.sidebarDesign {\n\tpadding: 50px 0 30px;\n\tbackground: var(--background-primary);\n}\n\n.sidebarContainer {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n\tpadding: 20px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.profileAvatarSection {\n\tposition: relative;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tborder-radius: 50%;\n}\n\n.profileName {\n\tfont-size: 16px;\n}\n\n.profileDetail {\n\tfont-size: 12px;\n\tcolor: var(--secondary-foreground);\n\tdisplay: flex;\n}\n\n.horizontalLine {\n\tmargin-top: 15px;\n\tmargin-bottom: 15px;\n\tborder: 0;\n\tborder-top: 2px solid var(--primary-border);\n}\n\n.textGray {\n\tcolor: var(--secondary-foreground);\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n/*************************Sidenavigation Styles End******************************************/\n/*************************Message Styles start******************************************/\n.contextPadding {\n\tpadding: 20px;\n\tborder-radius: 8px;\n}\n\n.rowCondensed {\n\tmargin-left: -6px;\n\tmargin-right: -6px;\n}\n\n.textBody {\n\tmargin: 0;\n\tpadding: 20px;\n\ttext-align: left;\n}\n\n.bottomButton {\n\ttext-align: right;\n\tpadding: 20px;\n}\n\n.textAreaBox {\n\theight: 77px !important;\n\tborder: 0px;\n\tmargin-top: 0;\n\tbox-shadow: none;\n\tborder: 1px solid var(--primary-border);\n\tresize: none;\n}\n\n.textAreaBox:focus,\n.textAreaBox:active {\n\tborder: 1px solid var(--primary-border) !important\n}\n\n.btnRight {\n\tmargin-left: 10px;\n}\n\n.timeText {\n\tcolor: var(--secondary-foreground);\n}\n\n.timeText:hover,\n.timeText:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\toutline: none;\n}\n\n/*************************Chat bubble Right & Left Styles start******************************************/\n.panelQuote {\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.panelBubble {\n\tdisplay: block;\n\tposition: relative;\n\theight: auto;\n\tborder-radius: 0;\n\tborder: none;\n\tbox-shadow: none;\n}\n\n.panelBubbleLeft::before {\n\tcontent: ' ';\n\tposition: absolute;\n\tdisplay: inline-block;\n\twidth: 0;\n\theight: 0;\n\tbottom: auto;\n\tborder: 10px solid transparent;\n\tborder-left: 0;\n\ttop: 0px;\n\tleft: initial;\n\tright: 100%;\n\tborder-width: 0 24px 24px 0;\n\tborder-color: transparent var(--primary-input-bg) transparent transparent;\n}\n\n.panelBubbleLeft::after {\n\tcontent: ' ';\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tleft: -20px;\n\tright: auto;\n\ttop: 0px;\n\tbottom: auto;\n\tborder-width: 0 22px 22px 0;\n\tborder-color: transparent var(--primary-gray-bg) transparent transparent;\n}\n\n.panelBubbleRight::before {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: -33px;\n\ttop: 0px;\n\tleft: 100%;\n\tborder: 10px solid transparent;\n\tborder-width: 25px 25px 0 0;\n\tborder-color: var(--primary-input-bg) transparent transparent;\n\tz-index: 3;\n}\n\n.panelBubbleRight::after {\n\tcontent: ' ';\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tleft: -20px;\n\tright: auto;\n\ttop: 0px;\n\tbottom: auto;\n\tborder-width: 0 25px 25px 0;\n\tborder-color: transparent var(--primary-border) transparent transparent;\n}\n\n.radiusColor::after {\n\tcontent: '';\n\tposition: absolute;\n\tright: -43px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 43px;\n\theight: 46px;\n\tbackground: var(--primary-gray-bg);\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n\tz-index: 3;\n}\n\n.radiusColorTwo::after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: -37px;\n\ttop: 0;\n\tright: auto;\n\twidth: 38px;\n\theight: 46px;\n\tbackground: var(--primary-gray-bg);\n\tborder-top-right-radius: 30px;\n\tborder-bottom-left-radius: 30px;\n\tz-index: 3;\n}\n\n.panelText {\n\tword-break: break-all !important;\n}\n\n/*************************Chat bubble Right & Left Styles end******************************************/\n/*************************Notification Message Styles start******************************************/\n.horizontalText {\n\toverflow: hidden;\n\ttext-align: center;\n}\n\n.textWrapper {\n\tposition: relative;\n}\n\n.textWrapper::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--primary-border);\n\twidth: 500px;\n\ttop: 50%;\n\tright: 100%;\n\tmargin-right: 18px;\n}\n\n.textWrapper::after {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--primary-border);\n\twidth: 500px;\n\ttop: 50%;\n\tleft: 100%;\n\tmargin-left: 18px;\n}\n\n/*************************Notification Message Styles end******************************************/\n.horizondalLine {\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textGray {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 14px;\n}\n\n.chevronIcon {\n\tfont-size: 1.5em;\n\tmargin-top: 10px;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.timerIcon {\n\tfont-size: 1.5em;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tposition: relative;\n\tbottom: 2px;\n}\n\n.checkInDate {\n\tfont-size: 14px;\n\tcolor: var(--primary-foreground);\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n/** Discount **/\n.discountText {\n\tcolor: var(--discountAndSpecial-color);\n}\n\na,\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n}\n\n.paddingRight {\n\tpadding: 0 0 0 35px;\n}\n\n.displayTable {\n\twidth: 100%;\n\tdisplay: table;\n}\n\n.displayTableRow {\n\twidth: 100%;\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.displayTableWidth {\n\twidth: 100%;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\tmargin: 0 0 0 6px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.displayTableCellTop {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.profileAvatarSectionLeft {\n\tposition: relative;\n\tz-index: 5;\n\tmargin: 0px 6px 0 0px;\n}\n\n\n.centerChatIcon {\n\theight: 45px;\n\twidth: 45px;\n\tmargin-left: -20px;\n\tmargin-right: -20px;\n\tposition: relative;\n\tz-index: 2;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.instantIcon {\n\tmargin-top: -4px;\n}\n\n.positionR {\n\tposition: relative;\n}\n\n.infoContentBlock {\n\tbackground-color: var(--tertiary-gray-bg);\n}\n\n.contentBlockHeading {\n\tfont-size: 18px;\n\tmargin-bottom: 12px;\n\tmargin-top: 0;\n\tfont-weight: 600;\n}\n\n.contentSectionBtn {\n\tmargin-top: 20px;\n\tdisplay: flex;\n}\n\n.contentSubText {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n/* =============New css ================*/\n.tripDetailHeading {\n\tfont-size: 16px;\n}\n\n.tripDetailGrey {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n}\n\n.paymentDetailText {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n}\n\n.paymentTotal {\n\tfont-size: 18px;\n}\n\n.messageBoxBg {\n\tbackground-color: var(--primary-gray-bg);\n\tpadding: 20px 20px 40px 20px;\n\tborder-radius: 8px;\n}\n\n.messageBoxStyle {\n\twidth: 90%;\n}\n\n.topMessageBar {\n\tbackground-color: transparent;\n}\n\n.messageSendIcon,\n.messageSendIcon:hover,\n.messageSendIcon:active,\n.messageSendIcon:focus {\n\tbackground: transparent !important;\n\tborder: 0 !important;\n\toutline: none;\n\tbox-shadow: none !important;\n\tpadding: 0;\n\tposition: relative;\n\tz-index: 5\n}\n\n.paddingNone {\n\tpadding: 0;\n}\n\n.messageBoxSection {\n\tpadding: 20px;\n\tbackground-color: var(--primary-gray-bg);\n\tborder-top-left-radius: 8px;\n\tborder-top-right-radius: 8px;\n}\n\n.panelBubble {\n\tmargin-bottom: 0;\n}\n\n.userDetailSec {\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 18px;\n\talign-items: center;\n\tmargin-bottom: 22px;\n}\n\n.userDetailHostName {\n\tfont-size: 16px;\n}\n\n.font16 {\n\tfont-size: 16px;\n}\n\n.nameSection {\n\tmargin-bottom: 8px;\n}\n\n.verifyReviewCountSec {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 3px;\n}\n\n.statusText {\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.dotText {\n\twidth: 4px;\n\theight: 4px;\n\tborder-radius: 50%;\n\tbackground-color: var(--primary-foreground);\n\tposition: absolute;\n\ttop: 38%;\n\n}\n\n.dateText {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tpadding-left: 8px;\n}\n\n.messageThreadSection {\n\tpadding: 0 20px 40px 20px;\n}\n\n.topRadiusColor::after {\n\tright: 50px;\n\ttop: 20px;\n\tborder-left: 1px solid var(--primary-border);\n}\n\n.topMessageBar::before {\n\tright: -23px;\n\ttop: 1px;\n\tleft: auto;\n}\n\n.panelBubbleLeft {\n\tbackground-color: var(--primary-input-bg);\n\tpadding: 17px;\n}\n\n.panelSendToBubble {\n\tbackground-color: var(--primary-input-bg);\n\tpadding: 17px;\n}\n\n.fromRadius:after {\n\tleft: 0px;\n\ttop: 0;\n\tright: auto;\n\twidth: 46px;\n\tborder-top-right-radius: 30px;\n\tborder-bottom-left-radius: 30px;\n}\n\n.toRadius:after {\n\tright: 4px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 46px;\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n}\n\n.panelSendToBubble:before {\n\tborder-color: var(--primary-input-bg) transparent transparent;\n}\n\n.panelSendToBubble::after {\n\tcontent: '';\n\tposition: absolute;\n\tright: -45px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 46px;\n\theight: 46px;\n\tbackground: var(--primary-gray-bg);\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n\tz-index: 3;\n\ttransform: rotate(-14deg);\n\n}\n\n.panelLeftMessage {\n\tborder-radius: 0 8px 8px 8px;\n}\n\n.panelRightMessage {\n\tborder-radius: 8px 0 8px 8px;\n}\n\n.messageDateText {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 10px;\n}\n\n.txtBreak {\n\tword-break: break-word;\n}\n\n.messageProfilePicSec {\n\twidth: 50px;\n}\n\n.width100 {\n\twidth: 100%;\n}\n\n.messageBoxFlex {\n\tdisplay: flex;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\twidth: 48px;\n}\n\n.profileAvatarSectionLeft .profileAvatarLink {\n\tposition: relative;\n\tright: 3px;\n\ttop: 1px;\n}\n\n.tripCheckinCheckout {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.userDetailDotText {\n\twidth: 3px;\n\theight: 3px;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-foreground);\n\tposition: relative;\n\tmargin-top: 7px;\n\tmargin-left: 7px;\n\tmargin-right: 7px;\n}\n\n.tripArrowSec {\n\tmargin: 0 10px;\n}\n\n.checkDate {\n\tword-break: break-word;\n}\n\n.paymentFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tcolumn-gap: 5px;\n}\n\n.timerSection {\n\tdisplay: flex;\n\tcolumn-gap: 3px;\n}\n\n/* ==============New css============== */\n.msgSendIcon {\n\twidth: 100%;\n\tmax-width: 72px;\n\tmin-width: 72px;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n\n\t.centerChatIcon {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t}\n\n\t.hostNameColor {\n\t\tcolor: var(--primary-foreground) !important;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.paddingRight {\n\t\tpadding: 0 0 0 0;\n\t}\n\n\t.panelBubbleRight::before {\n\t\tdisplay: none !important;\n\t}\n\n\t.panelBubbleLeft::before {\n\t\tdisplay: none !important;\n\t}\n\n\t.panelBubbleRight::after {\n\t\tdisplay: none;\n\t}\n\n\t.panelBubbleLeft::after {\n\t\tdisplay: none;\n\t}\n\n\t.profileAvatarSection {\n\t\tmargin: 0 0 0 13px;\n\t}\n\n\t.displayTableWidth {\n\t\twidth: 100%;\n\t}\n\n\t.displayTableWidthTwo {\n\t\twidth: 20%;\n\t}\n\n\t.profileAvatarSectionLeft {\n\t\tmargin: 0 10px 0 0;\n\t\tposition: relative;\n\t\tz-index: 5;\n\t}\n\n\t.radiusColor::after {\n\t\tdisplay: none;\n\t}\n\n\t.radiusColorTwo::after {\n\t\tdisplay: none;\n\t}\n\n\t.displayTableCell {\n\t\tdisplay: table-cell;\n\t\tvertical-align: middle;\n\t}\n\n\t.tripDetailGrey {\n\t\tfont-size: 14px;\n\t}\n\n\t.paymentDetailText {\n\t\tfont-size: 14px;\n\t}\n\n\t.paymentTotal {\n\t\tfont-size: 16px;\n\t}\n\n\t.tripDetailHeading {\n\t\tfont-size: 15px;\n\t}\n\n\t.userDetailSec {\n\t\tflex-direction: column;\n\t}\n\n\t.profileDetail {\n\t\tjustify-content: center;\n\t}\n\n\t.msgSendIcon {\n\t\tmax-width: 55px;\n\t\tmin-width: 55px;\n\t}\n\n\t.panelLeftMessage {\n\t\tborder-radius: 8px !important;\n\t}\n\n\t.panelRightMessage {\n\t\tborder-radius: 8px !important;\n\t}\n\n\t.sidebarDesign {\n\t\tpadding-top: 25px;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.hideSm {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 320px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n}\n\n@media screen and (min-width:768px) {\n\t.messageSendBtnSec {\n\t\tposition: relative;\n\t}\n\n\t.messageSendIcon::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 25px;\n\t\theight: 1px;\n\t\tbackground-color: var(--primary-border);\n\t\tleft: -3px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ViewMessage-errorMessage-qd6U_`,
	"space1": `ViewMessage-space1-IAIb3`,
	"space2": `ViewMessage-space2-xOEty`,
	"space3": `ViewMessage-space3-GGnhJ`,
	"space4": `ViewMessage-space4-LsssU`,
	"space5": `ViewMessage-space5-WLoOz`,
	"space6": `ViewMessage-space6-bFgEM`,
	"space7": `ViewMessage-space7-Ii5x2`,
	"spaceTop8": `ViewMessage-spaceTop8-lvOg2`,
	"spaceTop1": `ViewMessage-spaceTop1-BYJfd`,
	"spaceTop2": `ViewMessage-spaceTop2-nMoJy`,
	"spaceTop3": `ViewMessage-spaceTop3-JXdXB`,
	"spaceTop4": `ViewMessage-spaceTop4-P9W8F`,
	"spaceTop5": `ViewMessage-spaceTop5-BWiQj`,
	"spaceTop6": `ViewMessage-spaceTop6-bKwYl`,
	"spaceTop7": `ViewMessage-spaceTop7-LDaxa`,
	"noMargin": `ViewMessage-noMargin-VFPXH`,
	"padding1": `ViewMessage-padding1-Ya88_`,
	"padding2": `ViewMessage-padding2-wNoGn`,
	"padding3": `ViewMessage-padding3-isTUb`,
	"padding4": `ViewMessage-padding4-oAkjx`,
	"padding5": `ViewMessage-padding5-R2Yvd`,
	"padding6": `ViewMessage-padding6-rf9AJ`,
	"padding7": `ViewMessage-padding7-jrY7n`,
	"paddingTop1": `ViewMessage-paddingTop1-PUsTy`,
	"paddingTop2": `ViewMessage-paddingTop2-X_rL1`,
	"paddingTop3": `ViewMessage-paddingTop3-E1vwo`,
	"paddingTop4": `ViewMessage-paddingTop4-EJ8Uy`,
	"paddingTop5": `ViewMessage-paddingTop5-S2WC7`,
	"paddingTop6": `ViewMessage-paddingTop6-yUzut`,
	"paddingTop7": `ViewMessage-paddingTop7-irfLZ`,
	"noPadding": `ViewMessage-noPadding-w0U7c`,
	"textBold": `ViewMessage-textBold-MPjjr`,
	"textBolder": `ViewMessage-textBolder-QmYCz`,
	"textNormal": `ViewMessage-textNormal-BcwMP`,
	"spaceBottom20": `ViewMessage-spaceBottom20-xQqMC`,
	"spaceBottom10": `ViewMessage-spaceBottom10-YPNdE`,
	"marginNone": `ViewMessage-marginNone-cCfDh`,
	"spaceBottom15": `ViewMessage-spaceBottom15-caeBZ`,
	"marginTopNone": `ViewMessage-marginTopNone-CieKW`,
	"spaceTop11": `ViewMessage-spaceTop11-bsrgf`,
	"spaceTop21": `ViewMessage-spaceTop21-jlaRC`,
	"spaceTop20": `ViewMessage-spaceTop20-ACx8F`,
	"spaceTop10": `ViewMessage-spaceTop10-Q37c6`,
	"textDarkBlue": `ViewMessage-textDarkBlue-Pb7zA`,
	"textLightBlue": `ViewMessage-textLightBlue-UYkIK`,
	"textLightSandleGreen": `ViewMessage-textLightSandleGreen-3NU0a`,
	"textLightBrown": `ViewMessage-textLightBrown-rJZ69`,
	"textMediumMaroon": `ViewMessage-textMediumMaroon-t0qxE`,
	"textBrown": `ViewMessage-textBrown-C82zZ`,
	"textMaroon": `ViewMessage-textMaroon-XQY58`,
	"textDarkBrown": `ViewMessage-textDarkBrown-i_0qc`,
	"textMediumBrown": `ViewMessage-textMediumBrown-sVMVP`,
	"textSkyBlue": `ViewMessage-textSkyBlue-BPkzI`,
	"textGray": `ViewMessage-textGray-kvrP_`,
	"btnRadius": `ViewMessage-btnRadius-uBhQB`,
	"linkBtn": `ViewMessage-linkBtn-NcUzO`,
	"noBorder": `ViewMessage-noBorder-xX3_Z`,
	"sidebarDesign": `ViewMessage-sidebarDesign-ksVav`,
	"sidebarContainer": `ViewMessage-sidebarContainer-MQYxE`,
	"textCenter": `ViewMessage-textCenter-xGfiz`,
	"profileAvatarSection": `ViewMessage-profileAvatarSection-YnpHB`,
	"profileAvatarLink": `ViewMessage-profileAvatarLink-JbY1f`,
	"profileName": `ViewMessage-profileName-lQGzp`,
	"profileDetail": `ViewMessage-profileDetail-RmhC9`,
	"horizontalLine": `ViewMessage-horizontalLine-MU77P`,
	"textLeft": `ViewMessage-textLeft-JHA8n`,
	"textRight": `ViewMessage-textRight-nJUVX`,
	"contextPadding": `ViewMessage-contextPadding-PKgP_`,
	"rowCondensed": `ViewMessage-rowCondensed-_zS5a`,
	"textBody": `ViewMessage-textBody-sSpow`,
	"bottomButton": `ViewMessage-bottomButton-X0ib6`,
	"textAreaBox": `ViewMessage-textAreaBox-h1x3R`,
	"btnRight": `ViewMessage-btnRight-m9LgW`,
	"timeText": `ViewMessage-timeText-vvxwy`,
	"panelQuote": `ViewMessage-panelQuote-gE5KC`,
	"panelBubble": `ViewMessage-panelBubble-WSPGO`,
	"panelBubbleLeft": `ViewMessage-panelBubbleLeft-dOsS2`,
	"panelBubbleRight": `ViewMessage-panelBubbleRight-H8nLV`,
	"radiusColor": `ViewMessage-radiusColor-sRFF0`,
	"radiusColorTwo": `ViewMessage-radiusColorTwo-YXesC`,
	"panelText": `ViewMessage-panelText-gfVAg`,
	"horizontalText": `ViewMessage-horizontalText-cC8Kr`,
	"textWrapper": `ViewMessage-textWrapper-LAg_d`,
	"horizondalLine": `ViewMessage-horizondalLine-ZncGa`,
	"chevronIcon": `ViewMessage-chevronIcon-Dbvm9`,
	"timerIcon": `ViewMessage-timerIcon-XVOBb`,
	"checkInDate": `ViewMessage-checkInDate-sN1Q4`,
	"pullLeft": `ViewMessage-pullLeft-v6Sg0`,
	"pullRight": `ViewMessage-pullRight-lhseh`,
	"discountText": `ViewMessage-discountText-IrbbM`,
	"paddingRight": `ViewMessage-paddingRight-PNRo8`,
	"displayTable": `ViewMessage-displayTable-IENsR`,
	"displayTableRow": `ViewMessage-displayTableRow-Ghwre`,
	"displayTableCell": `ViewMessage-displayTableCell-tGyHw`,
	"displayTableWidth": `ViewMessage-displayTableWidth-h4VNN`,
	"displayTableCellTop": `ViewMessage-displayTableCellTop-rqz6z`,
	"profileAvatarSectionLeft": `ViewMessage-profileAvatarSectionLeft-YdIba`,
	"centerChatIcon": `ViewMessage-centerChatIcon-vQCgS`,
	"instantIcon": `ViewMessage-instantIcon-iB4lT`,
	"positionR": `ViewMessage-positionR-H8D2Y`,
	"infoContentBlock": `ViewMessage-infoContentBlock-d6sns`,
	"contentBlockHeading": `ViewMessage-contentBlockHeading-JjD4g`,
	"contentSectionBtn": `ViewMessage-contentSectionBtn-zBagA`,
	"contentSubText": `ViewMessage-contentSubText-TSfjx`,
	"tripDetailHeading": `ViewMessage-tripDetailHeading-UZDXp`,
	"tripDetailGrey": `ViewMessage-tripDetailGrey-oMHFu`,
	"paymentDetailText": `ViewMessage-paymentDetailText-bAaBv`,
	"paymentTotal": `ViewMessage-paymentTotal-AfmyK`,
	"messageBoxBg": `ViewMessage-messageBoxBg-MCCfR`,
	"messageBoxStyle": `ViewMessage-messageBoxStyle-rvjZd`,
	"topMessageBar": `ViewMessage-topMessageBar-DSzvM`,
	"messageSendIcon": `ViewMessage-messageSendIcon-Is4o4`,
	"paddingNone": `ViewMessage-paddingNone-uR88F`,
	"messageBoxSection": `ViewMessage-messageBoxSection-U5zf0`,
	"userDetailSec": `ViewMessage-userDetailSec-QdzIo`,
	"userDetailHostName": `ViewMessage-userDetailHostName-LTe2q`,
	"font16": `ViewMessage-font16-ZOxWA`,
	"nameSection": `ViewMessage-nameSection-pjfDN`,
	"verifyReviewCountSec": `ViewMessage-verifyReviewCountSec-je5yV`,
	"statusText": `ViewMessage-statusText-rdQM4`,
	"dotText": `ViewMessage-dotText-s6qBx`,
	"dateText": `ViewMessage-dateText-AjI2I`,
	"messageThreadSection": `ViewMessage-messageThreadSection-tq626`,
	"topRadiusColor": `ViewMessage-topRadiusColor-iNb18`,
	"panelSendToBubble": `ViewMessage-panelSendToBubble-iuPr8`,
	"fromRadius": `ViewMessage-fromRadius-FpRaN`,
	"toRadius": `ViewMessage-toRadius-TWtHL`,
	"panelLeftMessage": `ViewMessage-panelLeftMessage-tD7RT`,
	"panelRightMessage": `ViewMessage-panelRightMessage-L3cmO`,
	"messageDateText": `ViewMessage-messageDateText-gxvf0`,
	"txtBreak": `ViewMessage-txtBreak-jqn0N`,
	"messageProfilePicSec": `ViewMessage-messageProfilePicSec-sdBId`,
	"width100": `ViewMessage-width100-hzWDg`,
	"messageBoxFlex": `ViewMessage-messageBoxFlex-vT5gZ`,
	"tripCheckinCheckout": `ViewMessage-tripCheckinCheckout-e87nj`,
	"userDetailDotText": `ViewMessage-userDetailDotText-yHqHM`,
	"tripArrowSec": `ViewMessage-tripArrowSec-Bjmoo`,
	"checkDate": `ViewMessage-checkDate-Z_6ag`,
	"paymentFlex": `ViewMessage-paymentFlex-dOcgj`,
	"timerSection": `ViewMessage-timerSection-E1CMl`,
	"msgSendIcon": `ViewMessage-msgSendIcon-MRFzy`,
	"noPaddingRight": `ViewMessage-noPaddingRight-HhJpc`,
	"hostNameColor": `ViewMessage-hostNameColor-dZVwR`,
	"displayTableWidthTwo": `ViewMessage-displayTableWidthTwo-um83u`,
	"hideSm": `ViewMessage-hideSm-Fc3ir`,
	"displayFlex": `ViewMessage-displayFlex-FAZol`,
	"messageSendBtnSec": `ViewMessage-messageSendBtnSec-en4pi`
};
module.exports = ___CSS_LOADER_EXPORT___;
